<div class="cib-modal fade" ng-class="{'in': !closed}" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" id="new-clients">
    <section class="cib-modal-dialog xsmall" role="document">
        <article class="cib-modal-content">
            <header>
                <button ng-click="closed = true" class="h-link btn-close" type="button" aria-label="Close"><span class="icon-close" aria-hidden="true"></span></button>
                <div class="f-align--sb">
                    <div class="f-align">
                        <p class="h-lightbox margin-right-1 form-data">Déjanos tus datos</p>
                    </div>
                </div>
            </header>
            <main>
                <div class="cib-image-title">
                    <div class="cib-image-title-main">

                        <img src="{{openwebPath + '/' + 'images/icons/micro-success.png'}}" alt="Success form">
                        <h3 class="h-title">Hemos recibido tu<br> solicitud correctamente</h3>
                        <p>Nos pondremos en contacto contigo de <strong>lunes a viernes</strong> de <strong>8:00 a 19:00</strong>.</p>
                    </div>
                </div>
            </main>
        </article>
    </section>
</div>
